import React, { HTMLAttributes, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import { IMediaPageVideo } from "apiConsumers/kenticoApiConsumer/models/mediaPage/IMediaPageVideos";
import ItemGrid from "./itemGrid/ItemGrid";
import ClickableMediaItem from "./ClickableMediaItem";
import YouTubeVideoDialogThumbnail from "components/YouTubeVideoDialogThumbnail";
import PaginationButton from "components/pagination/PaginationButton";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            display: "flex",
            alignItems: "center",
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    videos: IMediaPageVideo[];
    isLoading?: boolean;
    numberOfItemsToDisplay: number;
}

export default function Videos(props: IProps) {
    const classes = useStyles();
    const { videos, isLoading = false, numberOfItemsToDisplay, className, ...rest } = props;

    const [currentPage, setCurrentPage] = useState<number>(0);

    const showPagination = videos.length > numberOfItemsToDisplay;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {showPagination ? (
                <>
                    <PaginationButton
                        variant="previous"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(currentPage - 1)}
                    />
                    <Spacer />
                </>
            ) : null}

            {isLoading ? (
                <ItemGrid
                    items={Array.from(Array(numberOfItemsToDisplay)).map((_) => {
                        return <YouTubeVideoDialogThumbnail isLoading={isLoading} videoId={""} />;
                    })}
                />
            ) : (
                <ItemGrid
                    items={videos
                        .slice(
                            currentPage * numberOfItemsToDisplay,
                            (currentPage + 1) * numberOfItemsToDisplay
                        )
                        .map((video) => {
                            return (
                                <ClickableMediaItem>
                                    <YouTubeVideoDialogThumbnail videoId={video.id} />
                                </ClickableMediaItem>
                            );
                        })}
                />
            )}

            {showPagination ? (
                <>
                    <Spacer />
                    <PaginationButton
                        variant="next"
                        disabled={
                            videos.length <=
                            currentPage * numberOfItemsToDisplay + numberOfItemsToDisplay
                        }
                        onClick={() => setCurrentPage(currentPage + 1)}
                    />
                </>
            ) : null}
        </div>
    );
}
